import glamorous from 'glamorous';
import { css } from 'glamor'
import themes from '../themes'

const grow = css.keyframes({
    "0%": { transform: "scale(0.99)" },
    "100%": { transform: "scale(1.10)" }
})
export default glamorous.div(
    {
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        width: "50px",
        height: "50px",
        left: "50%",
        top: "50%",
        marginLeft: "-25px",
        marginTop: "-25px",
        border: "1px solid",
        animation: `${grow} 1s infinite ease-in-out alternate`,
         },
        props => {
            if (props.theme === "dark") {
                return { color: themes[0].text }
            }
            else {
                return { color: themes[1].text}
            }
        }
    
);




// WEBPACK FOOTER //
// ./src/components/Loader.js